import { Bar } from "react-chartjs-2";
import {
  Chart,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { ChartOptions } from "chart.js";

// Register necessary components
Chart.register(BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

const StackedBarChart = ({ data }: any) => {
  const options: ChartOptions<"bar"> = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          font: {
            size: 17, 
            weight: 'bold', 
          },
        },
      },
      title: {
        display: true,
      },
      datalabels: {
        display: true,
        color: "white",
        font: {
          size: 20,
        },
      },
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: 14, 
            weight: 'bold', 
          },
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          font: {
            size: 14, 
            weight: 'bold', 
          },
        },
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default StackedBarChart;
